var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 264,
    viewBox: "0 0 1440 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.069 185.596C499.888 195.462 720 206.497 720 264C720 206.497 940.112 195.462 1136.93 185.596C1296.08 177.617 1440 170.402 1440 140V0H720H0V140C0 170.402 143.919 177.617 303.069 185.596Z",
    fill: "url(#paint0_linear_94_263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.069 185.596C499.888 195.462 720 206.497 720 264C720 206.497 940.112 195.462 1136.93 185.596C1296.08 177.617 1440 170.402 1440 140V0H720H0V140C0 170.402 143.919 177.617 303.069 185.596Z",
    fill: "url(#paint1_linear_94_263)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_94_263",
    x1: 749.572,
    y1: 0,
    x2: 749.572,
    y2: 458.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDFE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_94_263",
    x1: -3.36662e-7,
    y1: 57,
    x2: 1440,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203294,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498812,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79904,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.0a49739f31a001cdffd19a36a60e0165.svg";
export { ForwardRef as ReactComponent };